export enum LabelTypes {
    AggregateLabel,
    DualColumnLabel,
    LinearLabel,
    SupplementLabel,
}